import { DisplayBalance } from '@/modules/lobby/components/DisplayBalance';
import { HostProps } from '@/utils/commonFunc';
import Grid from '@mui/material/Grid';
import { TotalBetAmount } from './TotalBetAmount';
export const FONT_SIZE = { xs: '14px', md: '17px', lg: '22px' };
export const BalanceInfo = (props: HostProps) => {
    return (
        <Grid container direction={'column'}>
            <Grid item xs>
                <TotalBetAmount {...props} />
            </Grid>
            <Grid item xs>
                <DisplayBalance />
            </Grid>
        </Grid>
    );
};
